import PropTypes from 'prop-types'
import { getImage } from 'gatsby-plugin-image'
import { convertToBgImage } from 'gbimage-bridge'
import BackgroundImage from 'gatsby-background-image'

function GbiBridged({ className, image, children }) {
  const bgImage = convertToBgImage(getImage(image))

  return (
    <BackgroundImage className={className} {...bgImage} preserveStackingContext critical>
      {children}
    </BackgroundImage>
  )
}

GbiBridged.propTypes = {
  image: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node
}

export default GbiBridged
